import { render, staticRenderFns } from "./LimitTransaction.vue?vue&type=template&id=29749c1e&scoped=true&"
import script from "./LimitTransaction.vue?vue&type=script&lang=js&"
export * from "./LimitTransaction.vue?vue&type=script&lang=js&"
import style0 from "./LimitTransaction.vue?vue&type=style&index=0&id=29749c1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29749c1e",
  null
  
)

export default component.exports